import src from "IMAGE";
export default { src, width: 25, height: 32, blurWidth: 0, blurHeight: 0};
